export default "__VITE_ASSET__BVrbeMTX__"